import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { ButtonGraph } from '../../../components/button-graph'
import { PanelContent } from '../../../components/panel-content'
import { useStateValue } from '../../../components/state'
import { TextLink } from '../../../components/text-link'
import { facts } from './facts'
import { FactGroup } from '../../../components/fact-group'

export const ReuseHome: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to all
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'all' }
    })
  }, [dispatch])

  return (
    <PanelContent>
      <h1>Where does your water go?</h1>
      <p>
        Once water has finished going through your shower, sink, washing machine
        or toilet, we take it away via over 12,000km of{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Wastewater/Our-wastewater-system'>
          wastewater
        </TextLink>{' '}
        pipes to one of our{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Wastewater/How-wastewater-is-treated'>
          wastewater treatment
        </TextLink>{' '}
        plants. From there it goes to:
      </p>
      <ButtonGraph
        href='recycled-irrigation'
        title='Recycled for irrigation'
        icon='recycle-irrigation'
      />
      <ButtonGraph
        href='recycled-industry'
        title='Recycled for industry use'
        icon='recycle-industry'
      />
      <ButtonGraph
        href='groundwater-replenishment'
        title='Groundwater replenishment'
        icon='groundwater-replenishment'
      />
      <ButtonGraph
        href='ocean-outfall'
        title='Ocean outfall'
        icon='ocean-outfall'
      />
      <FactGroup data={facts} />
    </PanelContent>
  )
}
